import { baseUrl } from "../../utils/env";
import axios from "axios";
import {
  VISA_LIST_FAIL,
  VISA_LIST_REQUEST,
  VISA_LIST_SUCCESS,
  VISA_UPDATE_REQUEST,
  VISA_UPDATE_RESET,
  VISA_UPDATE_SUCCESS,
} from "../constants/visaConstant";
import { toast } from "react-toastify";

export const listVisaDescription = (tag) => async (dispatch) => {
  try {
    dispatch({ type: VISA_LIST_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(`${baseUrl}/visa/${tag}`, config);

    dispatch({
      type: VISA_LIST_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: VISA_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
export const updateVisaDescription =
  (description, descriptionId) => async (dispatch, getState) => {
    try {
      dispatch({ type: VISA_UPDATE_REQUEST });
      const {
        adminLogin: { adminInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `${baseUrl}/visa/${descriptionId}`,
        {
          description,
        },
        config
      );

      toast.info("Visa Updated Successfully", {
        autoClose: 1000,
      });
      dispatch({
        type: VISA_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (err) {
      toast.error("Fail To Update Visa", {
        autoClose: 1000,
      });
      dispatch({
        type: VISA_UPDATE_RESET,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
